import React, { useState } from 'react';
import { connect } from 'react-redux';
import { signupActions } from '../../actions/user/signupActions.js';
import { Redirect, Link } from 'react-router-dom';
import { Form, Button, Container, Row, Col, Alert } from 'react-bootstrap';
import Logo from '../common/logo.js';

function Signup(props) {
    /**local state for form inputs */
    const [formData, setFormData] = useState({
        email: '',
        username: '',
        redditUsername: '',
        password: '',
        confirmPassword: ''
    });
    const [errors, setErrors] = useState({});
    const [error, setError] = useState('');

    /**submit credentials to userAPI */
    const handleSubmit = (e) => {
        e.preventDefault();
        const { email, username, redditUsername, password, confirmPassword } = formData;

        const newErrors = {};
        if (!email) newErrors.email = 'Email is required.';
        if (!username) newErrors.username = 'Username is required.';
        if (!redditUsername) newErrors.redditUsername = 'Reddit username is required.';
        if (!password) newErrors.password = 'Password is required.';
        if (!confirmPassword) newErrors.confirmPassword = 'Confirm password is required.';
        if (password && confirmPassword && password !== confirmPassword) {
            newErrors.confirmPassword = 'Passwords do not match.';
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setError('Please fix the highlighted fields.');
            return;
        }

        setErrors({});
        setError('');
        props.signup(email, username, redditUsername, redditUsername, password);
    };

    return (
        <>
            {props.authorized ? <Redirect to={{ pathname: '/profile' }} /> :
                <Container
                    className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: '100vh' }}
                >
                    <Row className="w-100">
                        <Col md={{ span: 6, offset: 3 }}>
                            <div className="p-4 border rounded shadow-sm bg-white">
                                <Logo />
                                <h2 className="text-center mb-4">Signup</h2>
                                {error && <Alert variant="danger">{error}</Alert>}
                                {props.error && <Alert variant="danger">{props.error}</Alert>}
                                {props.signupError && (
                                    <Alert variant="danger">Signup failed. Please try again.</Alert>
                                )}
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group controlId="formEmail" className="mb-3">
                                        <Form.Label>Email address</Form.Label>
                                        <Form.Control
                                            type="email"
                                            placeholder="Enter email"
                                            value={formData.email}
                                            onChange={(e) =>
                                                setFormData({ ...formData, email: e.target.value })
                                            }
                                            className={errors.email ? 'is-invalid' : ''}
                                        />
                                        {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                    </Form.Group>
                                    <Form.Group controlId="formUsername" className="mb-3">
                                        <Form.Label>Username</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter username"
                                            value={formData.username}
                                            onChange={(e) =>
                                                setFormData({ ...formData, username: e.target.value })
                                            }
                                            className={errors.username ? 'is-invalid' : ''}
                                        />
                                        {errors.username && <div className="invalid-feedback">{errors.username}</div>}
                                    </Form.Group>
                                    <Form.Group controlId="formReddit" className="mb-3">
                                        <Form.Label>Reddit username</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter reddit username"
                                            value={formData.redditUsername}
                                            onChange={(e) =>
                                                setFormData({ ...formData, redditUsername: e.target.value })
                                            }
                                            className={errors.redditUsername ? 'is-invalid' : ''}
                                        />
                                        {errors.redditUsername && (
                                            <div className="invalid-feedback">{errors.redditUsername}</div>
                                        )}
                                    </Form.Group>
                                    <Form.Group controlId="formPassword" className="mb-3">
                                        <Form.Label>Password</Form.Label>
                                        <Form.Control
                                            type="password"
                                            placeholder="Password"
                                            value={formData.password}
                                            onChange={(e) =>
                                                setFormData({ ...formData, password: e.target.value })
                                            }
                                            className={errors.password ? 'is-invalid' : ''}
                                        />
                                        {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                                    </Form.Group>
                                    <Form.Group controlId="formConfirmPassword" className="mb-3">
                                        <Form.Label>Confirm Password</Form.Label>
                                        <Form.Control
                                            type="password"
                                            placeholder="Confirm Password"
                                            value={formData.confirmPassword}
                                            onChange={(e) =>
                                                setFormData({
                                                    ...formData,
                                                    confirmPassword: e.target.value
                                                })
                                            }
                                            className={errors.confirmPassword ? 'is-invalid' : ''}
                                        />
                                        {errors.confirmPassword && (
                                            <div className="invalid-feedback">{errors.confirmPassword}</div>
                                        )}
                                    </Form.Group>
                                    <Button variant="primary" type="submit" className="w-100">
                                        Signup
                                    </Button>
                                </Form>
                                <div className="text-center mt-3">
                                    <Link to="/login">Already have an account? Login</Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            }</>
    );
}

const mapStateToProps = (state) => {
    return {
        isFetching: state.users.user.signup.isFetching,
        authorized: state.users.user.authorized,
        error: state.users.user.signup.errorMsg,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        signup: (email, username, firstname, lastname, pass) => dispatch(signupActions.signup(firstname, lastname, username, email, pass))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(Signup);